import styled from 'styled-components';
import { buttonBase, getButtonSize, stretchButton } from 'modules/buttonStyles';
import { getFilterButtonAppearance } from './utils';
export const FilterButton = styled.button `
  ${buttonBase};
  ${stretchButton};

  ${(props) => getButtonSize(props.size || 'xs')};
  ${(props) => getFilterButtonAppearance(props.appearance)};
`;
